
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.692 14.021c0-.87.716-1.585 1.585-1.585.87 0 1.585.716 1.585 1.585 0-.87.715-1.585 1.585-1.585s1.584.716 1.584 1.585M6.938 11.644c0-2.173 1.789-3.962 3.962-3.962s3.962 1.789 3.962 3.962","stroke":"currentColor","stroke-width":"1.585","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M14.862 18.775v-7.131c0-2.173 1.789-3.962 3.962-3.962s3.962 1.789 3.962 3.962M3.769 18.775h22.186","stroke":"currentColor","stroke-width":"1.585","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M4.966 21.732h19.791","stroke":"currentColor","stroke-width":"1.589","stroke-miterlimit":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.5 24.688h16.955","stroke":"currentColor","stroke-width":"1.546","stroke-miterlimit":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    